import React from 'react';
import noop from 'lodash-es/noop';
import { ZipInput } from 'site-modules/shared/components/zip-input/zip-input';
import { ZipPresentationComponent } from 'site-modules/lease-deals/components/filters/ui/zip-input/zip-input';

import './zip-control.scss';

export function ZipControl() {
  return (
    <div className="px-1_5">
      <ZipInput inputComponent={ZipPresentationComponent} withErrorText fireTrackingZipChange={noop} />
      <hr className="location-hr mt-1_25 mb-0" />
    </div>
  );
}
